import { render, staticRenderFns } from "./EmployeeExtensionField.vue?vue&type=template&id=70f02045&"
import script from "./EmployeeExtensionField.vue?vue&type=script&lang=js&"
export * from "./EmployeeExtensionField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f02045')) {
      api.createRecord('70f02045', component.options)
    } else {
      api.reload('70f02045', component.options)
    }
    module.hot.accept("./EmployeeExtensionField.vue?vue&type=template&id=70f02045&", function () {
      api.rerender('70f02045', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeExtensionField.vue"
export default component.exports